import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M3_DynamicMemoryAllocation = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Dynamic Memory Allocation"
    videos={[
      "https://www.youtube.com/embed/7RNesIP9Ot0",
      "https://www.youtube.com/embed/4ZhRiWM8eUk",
    ]}
    takeaways={[
      {
        text: "Entire theory part with basic code examples.",
      },
      {
        text: "Mainly theory questions are possible, particularly the advantages of dynamic memory allocation and the differences between malloc() and calloc().",
      },
      {
        text: "Learn the syntax properly.",
      },
    ]}
    questions={[
      
    ]}
    exampleVideos={[]} // No extra example videos for now
  />
);
}

export default OOPS_M3_DynamicMemoryAllocation;
